const HighRpsOfferCustom = ({
  color = '#FF4F17',
  width = 96,
  height = 93,
}: {
  color?: string
  width?: number
  height?: number
}) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 96 93' fill='none'>
      <g opacity='0.1'>
        <path
          d='M45.4646 7.19969C46.9193 5.93762 49.0807 5.93762 50.5354 7.19969L55.2745 11.3113C56.1721 12.0901 57.3777 12.4131 58.5444 12.1875L64.7045 10.9963C66.5953 10.6306 68.4671 11.7113 69.0959 13.5317L71.1442 19.462C71.5322 20.5852 72.4148 21.4678 73.538 21.8558L79.4683 23.9041C81.2887 24.5329 82.3694 26.4047 82.0037 28.2955L80.8125 34.4556C80.5869 35.6223 80.9099 36.8279 81.6887 37.7255L85.8003 42.4646C87.0624 43.9193 87.0624 46.0807 85.8003 47.5354L81.6887 52.2745C80.9099 53.1721 80.5869 54.3777 80.8125 55.5444L82.0037 61.7045C82.3694 63.5953 81.2887 65.4671 79.4683 66.0959L73.538 68.1442C72.4148 68.5322 71.5322 69.4148 71.1442 70.538L69.0959 76.4683C68.4671 78.2887 66.5953 79.3694 64.7045 79.0037L58.5444 77.8125C57.3777 77.5869 56.1721 77.9099 55.2745 78.6887L50.5354 82.8003C49.0807 84.0624 46.9193 84.0624 45.4646 82.8003L40.7255 78.6887C39.8279 77.9099 38.6223 77.5869 37.4556 77.8125L31.2955 79.0037C29.4047 79.3694 27.5329 78.2887 26.9041 76.4683L24.8558 70.538C24.4678 69.4148 23.5852 68.5322 22.462 68.1442L16.5317 66.0959C14.7113 65.4671 13.6306 63.5953 13.9963 61.7045L15.1875 55.5444C15.4131 54.3777 15.0901 53.1721 14.3113 52.2745L10.1997 47.5354C8.93762 46.0807 8.93762 43.9193 10.1997 42.4646L14.3113 37.7255C15.0901 36.8279 15.4131 35.6223 15.1875 34.4556L13.9963 28.2955C13.6306 26.4047 14.7113 24.5329 16.5317 23.9041L22.462 21.8558C23.5852 21.4678 24.4678 20.5852 24.8558 19.462L26.9041 13.5317C27.5329 11.7113 29.4047 10.6306 31.2955 10.9963L37.4556 12.1875C38.6223 12.4131 39.8279 12.0901 40.7255 11.3113L45.4646 7.19969Z'
          stroke={color}
          strokeWidth='4.72131'
        />
        <path d='M64 29L32 61' stroke={color} strokeWidth='4.72131' strokeLinecap='round' strokeLinejoin='round' />
        <path
          d='M36.1914 33.6484H36.3041'
          stroke={color}
          strokeWidth='11.6066'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M60.1914 57.6484H60.3041'
          stroke={color}
          strokeWidth='11.6066'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export default HighRpsOfferCustom
